import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return(
    <SettingsMetaData propertyName={"PackingListStatus"} viewPropertyName={"Packing List Status"} />
  )
};

export default Status;
